import api from '../../../lib/api';

export default {
  async verifyStatusAccountToken({ commit }, token) {
    const payload = await api.customers.verifyStatusAccountToken(token);

    const {
      session,
      customer,
      companyId,
      clientId: customerId,
    } = payload;

    const { ...auth } = session;

    commit('setValue', { accessor: 'temporal.customerId', value: customerId });
    commit('setValue', { accessor: 'temporal.companyId', value: companyId });
    commit('setValue', { accessor: 'temporal.creditLimit', value: customer.creditLimit });
    commit('setValue', { accessor: 'temporal.name', value: customer.name });
    commit('setValue', { accessor: 'temporal.email', value: customer.email });
    commit('setValue', { accessor: 'temporal.creditDays', value: customer.creditDays });
    commit('setValue', { accessor: 'temporal.rfc', value: customer.rfc });
    commit('setValue', { accessor: 'temporal.companyName', value: customer.companyName });
    commit('setValue', { accessor: 'temporal.cellphoneNumber', value: customer.cellphoneNumber });
    commit('setValue', { accessor: 'temporal.accountStatus', value: customer.accStatusToken });

    commit(
      'auth/setValues', {
        ...auth,
        signed: true,
      }, { root: true },
    );

    return payload;
  },

  async getSingle({ commit, rootState }, customer) {
    const { companyId: company } = rootState.auth;

    const payload = await api.customers.getSingleByCompany(company, customer);

    const [debts, debtsExpired, debtsCustomer, debtCreditLimit] = await Promise.all([
      api.balances.getAllDebts({ id: payload.id }),
      api.balances.getAllDebtsExpired({ customer: payload.id }),
      api.balances.getAllDebtsCustomer({ customer: payload.id }),
      api.balances.getDebtsCreditLimit({ customer: payload.id }),

    ]);

    commit('setValues', {
      ...payload,
      debts,
      debtsExpired,
      debtsCustomer,
      debtCreditLimit,
    });

    return payload;
  },

  async getById({ commit, rootState }, customer) {
    const { companyId: company } = rootState.auth;

    const payload = await api.customers.getById(company, customer);

    commit('setValues', { ...payload });

    return payload;
  },

  async customersGetSingle({ commit }) {
    const [debts, debtsExpired, debtsCustomer, debtCreditLimit] = await Promise.all([
      api.balances.customersGetAllDebts(),
      api.balances.customersGetAllDebtsExpired(),
      api.balances.customersGetAllDebtsCustomer(),
      api.balances.customersGetDebtsCreditLimit(),
    ]);

    commit('setValue', { accessor: 'temporal.debts', value: debts });
    commit('setValue', { accessor: 'temporal.debtsExpired', value: debtsExpired });
    commit('setValue', { accessor: 'temporal.debtsCustomer', value: debtsCustomer });
    commit('setValue', { accessor: 'temporal.debtCreditLimit', value: debtCreditLimit });

    return {
      debts,
      debtsExpired,
      debtsCustomer,
      debtCreditLimit,
    };
  },

  async getSingleForRep({ commit, rootState }, customer) {
    const { companyId: company } = rootState.auth;

    const payload = await api.customers.getSingleByCompany(company, customer);
    const { name, email } = payload;
    commit(
      'users/setValues', { name, email }, { root: true },
    );
    commit(
      'invoice/setValues', { receiverName: payload.companyName, receiverRfc: payload.rfc }, { root: true },
    );

    commit('setValues', payload);

    return payload;
  },

  async deleteSingle({ rootState }, customer) {
    const { companyId: company } = rootState.auth;

    const payload = await api.customers.deleteSingleByCompany(company, customer);

    return payload;
  },

  async getAll({ commit, rootState }, { size, page, ...fields }) {
    const { companyId } = rootState.auth;

    const filters = fields;

    commit('setValue', { accessor: 'loading', value: true });

    const payload = await api.customers.getAllByCompany(
      companyId, filters, page, size,
    );

    const { count, rows } = payload;

    commit('setValues', {
      count,
      list: rows,
      loading: false,
    });

    return payload;
  },

  async create({ state, rootState }) {
    const { companyId: company } = rootState.auth;

    const {
      email,
      name,
      rfc,
      companyName,
      creditDays,
      creditLimit,
      cellphoneNumber,
      zipCode,
      taxRegime,
    } = state;

    const { payload } = await api.customers.createByCompany(company, {
      email,
      name,
      rfc,
      companyName,
      creditDays,
      creditLimit,
      cellphoneNumber,
      zipCode,
      taxRegime,
    });

    return payload;
  },

  async update({ state, rootState }) {
    const { companyId: company } = rootState.auth;

    const {
      email,
      name,
      rfc,
      companyName,
      id,
      creditDays,
      creditLimit,
      cellphoneNumber,
      zipCode,
      taxRegime,
    } = state;

    const { payload } = await api.customers.updateSingleByCompany(company, id, {
      email,
      name,
      rfc,
      companyName,
      creditDays,
      creditLimit,
      cellphoneNumber,
      zipCode,
      taxRegime,
    });

    return payload;
  },

  async bulkUpload({ state, commit, rootState }) {
    const { csv } = state;
    const { companyId: company } = rootState.auth;

    const formData = new FormData();
    formData.append('file', csv);

    const payload = await api.customers.bulkUpload(company, formData);

    commit('setValues', { csv: null, csvFileName: '' });
    commit('setValues', {
      list: payload,
      loading: false,
    });

    return payload;
  },
  async sendStatusAccountEmail(store, { customerId, companyId }) {
    const payload = await api.customers.sendStatusAccount(
      customerId,
      companyId,
    );

    return payload;
  },
  async deleteStatusAccount(store, { customerId, companyId }) {
    const payload = await api.customers.deletestatusAccountByCompany(
      customerId,
      companyId,
    );

    return payload;
  },
};
